// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avenue -> weidner-apartment-homes-avenue -> rancho-belago
// Generated: 2026-10-28T17:36:15.687Z
// Counts: 1 design, 38 content, 22 slot group, 1 collection binding, 11 section, 0 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_full_address"
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "<p>All Rights Reserved. <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_interactivemap_blurb"
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": "virtual tour",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_name"
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=48/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.inject_dni_classes": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Contact Us",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "cort-lead-form.form_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_cort_lead_form_id"
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 11pt;\">Browse the Rancho Belago photo gallery and imagine relaxing afternoons at the resort-style pool, meals in your modern kitchen, and cozy nights in spacious living rooms. See sunlit bedrooms, inviting social spaces, and elegant touches throughout your potential new home. Ready to see more? Schedule an in-person or virtual tour and find where you fit in.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "header.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Pit Bull &amp; Pit Bull Mixes</p></li><li><p>American Pit Bull Terrier</p></li><li><p>American Staffordshire Terrier</p></li><li><p>Wolf Hybrids</p></li><li><p>Doberman Pinscher</p></li><li><p>Saint Bernard</p></li><li><p>American Bulldog</p></li><li><p>Staffordshire Bull Terrier</p></li><li><p>Rottweiler</p></li><li><p>German Shepherd</p></li><li><p>Chow Chow</p></li><li><p>Great Dane</p></li><li><p>Akita</p></li></ul><p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 11pt;\">At Rancho Belago in Moreno Valley, discover spacious apartments and inviting community amenities designed for comfort and connection. Unwind in your home with features like in-unit laundry, fireplaces, and granite countertops. Step outside to enjoy a resort-style pool, fitness center, or catch a movie in the on-site theater. Everything you need for easy living is at your fingertips in our pet-friendly community.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 11pt;\">Ready to make Rancho Belago your next home? Reach out to our leasing team for fast, friendly answers—whether you're curious about floor plans or booking a tour. We're here to support you from your first question to move-in day.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 11pt;\">Whether you need a cozy one-bedroom or spacious two or three-bedroom home, Rancho Belago apartments for rent in Moreno Valley, CA, offer a range of floor plans perfect for relaxation, entertaining, or working from home. Each layout features generous storage, an in-unit washer and dryer, and a dedicated dining space - giving you room to live, work, and unwind your way.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "frc-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Future Residents Club",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 11pt;\">Picture weekends at Moreno Valley Mall, fresh finds at Costco, or nights out around vibrant local restaurants. Nestled close to the University of Riverside and just off the 60 Freeway, Rancho Belago puts you close to everything that makes Moreno Valley feel like home. With nearby parks and easy access to work or campus, you'll experience a truly connected lifestyle—all in a community that's warm, lively, and inviting.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Cats and dogs are welcome! Pets – max 2 allowed. Monthly pet rent: $50 per pet. Refundable pet deposit: $500 for first pet, $300 for second pet. No one‑time pet fee or weight limit.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 11pt;\">Searching for apartments for rent in Moreno Valley, CA? Rancho Belago welcomes you to a community designed for comfort, connection, and ease. Choose a home with an in-unit washer and dryer, a full appliance package, and elegant finishes. Relax at the sparkling pool, get active in the 24-hour fitness center, or host friends in the resident lounge. Here, you're close to shopping, dining, and commuting via HWY 60, so every day feels just right.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 11pt;\">Take the stress out of your apartment search at Rancho Belago. Choose a guided in-person tour, a live virtual walk-through, or self-schedule a web chat; whatever works for your pace. Our friendly team is ready to help you explore floor plans, ask questions, and find your next home in Moreno Valley. Touring restrictions may apply.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 11pt;\">Wondering what life at Rancho Belago feels like? Our virtual tour lets you wander through stylish interiors, tour sunlit living spaces, and discover the welcoming atmosphere that sets our community apart. Whether you're near or far, picture your day-to-day routine—and start imagining your new home in Moreno Valley before you even visit.</span></p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.repli360.com"
      }
    }
  },
  "footer.powered_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/5715369763274752/019d01a1-3f7d-77af-9dea-e6206da4f134.webp"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://www.multihub.io"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "footer.love_notes_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d44f3-3412-75a9-9aac-8f5678cb59df.webp"
      }
    }
  },
  "footer.weidner_cares_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d44f3-3452-767e-8966-83b6939f057f.webp"
      }
    }
  },
  "footer.youtube_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.youtube.com/@WeidnerApartmentHomes"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      }
    }
  },
  "_template:hyperlocal::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "contact-hero.bg_image": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "footer.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-5808-766c-b25e-ab27c2e3766f.webp"
      }
    }
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 19,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d0727-d65c-70bf-9716-4ecdf5123562.webp"
      }
    }
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 27,
    "fieldOverrides": null
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": 27,
    "fieldOverrides": null
  },
  "resident-access-hero.bg_image": {
    "sourceIndex": 22,
    "fieldOverrides": null
  },
  "socialfollow.yelp_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.yelp.com/biz/rancho-belago-moreno-valley-3?osq=Rancho+Belago"
      }
    }
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 13,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "ec_f737bd825edb9563933c59ec"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      1
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "cort-lead-form",
      "blockId": "cort-lead-form",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 11
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 11
    }
  ]
};

export const styleOverrides = {};
